import React, { useEffect, useState, useRef, useCallback } from "react"
import Col from "@bappweb/col"
import Grid from "@bappweb/grid"
import Row from "@bappweb/row"
import Block from "@bappweb/block"
import { pushGtmValues, BAPPgetElementById } from "@bappweb/utils"
import MainForm from "./form"
import LandingHeader from "./landingheader"
import Campaign from "./campaign"
import SssList from "./ssslist"
import Notes from "./notes"
import LandingFooter from "./landingfooter"
import Toolbar from "./toolbar"
import "../assets/style.scss"

const Landing = () => {
    const ref = useRef() as React.RefObject<HTMLDivElement>

    const [bottomToolbarVisible, setBottomToolbarVisible] = useState(false)
    const applyButtonId = "applyNowButton"

    useEffect(() => {
        pushGtmValues({
            event: 'virtual_page_view',
            content_group: 'fav',
            pageName: '/basvuru/fav/0/landing',
            pageTitle: 'FAV'
        })

        const block = ref.current
        block?.addEventListener("scroll", handleScroll) // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleScroll = useCallback(() => {
        const applyBtn = BAPPgetElementById(applyButtonId)
        let rect = { bottom: 0 }
        if (applyBtn) {
            rect = applyBtn.getBoundingClientRect()
            setBottomToolbarVisible(rect?.bottom <= 0)
        }

    }, [])

    const onToolbarButtonClick = () => {
        BAPPgetElementById(applyButtonId)?.click()
    }

    return (
        <div ref={ref}>
            <Block type="section" className="landing-page-wrapper" id="landing-page-wrapper">
                <LandingHeader />
                <Grid type="main" className="landing-page-main">
                    <Row>
                        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1} className="landing-initialinfo-col">
                            <MainForm />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                            <Campaign />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                            <SssList />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
                            <Notes />
                        </Col>
                    </Row>
                </Grid>
                <LandingFooter scrollHref="#landing-page-wrapper" />
                <Toolbar onApplyClick={onToolbarButtonClick} scrollHref="#landing-page-wrapper" isVisible={bottomToolbarVisible} text={"Hemen Başvur"} />
            </Block>
        </div>
    )
}

export default Landing
